<template>

  <div
    :class="{'show': true, 'is-more': isMore, 'disabled': isDisabled}"
  >
    <div class="cont" @click="toggle" ref="rootEl">
      <template v-if="isMore">
        {{ originalText }}
        <span v-if="!isDisabled" class="toggler less">… less</span>
      </template>

      <template v-else>
        <span class="content">{{ trimmedText }}</span>
        <span v-if="!isDisabled" class="toggler more">… more</span>
      </template>
    </div>
  </div>
  
</template>

<script setup lang="ts">

import { ref, defineExpose } from 'vue'

const rootEl = ref<HTMLElement | null>(null)

// defineExpose({ rootEl })

const props = defineProps({
  /** Maximum number of characters that will be shown when collapsed */
  charLimit: {
    type: Number,
    default: 100,
  },
  rowsLimit: {
    type: Number,
    default: 3,
  },
  text: {
    type: String,
    default: '',
  },
});

const isMore = ref(false);


const originalText = computed(() => (props.text || '').trim());
const originalLines = computed(() => originalText.value.split(/\r?\n/));

const isDisabled = computed(() =>
  originalText.value.length <= props.charLimit &&
  originalLines.value.length <= props.rowsLimit
);

const trimmedText = computed(() => {
  if (isDisabled.value) return originalText.value;

  // take only the first rowsLimit lines
  const limitedLines = originalLines.value.slice(0, props.rowsLimit);
  let result = limitedLines.join('\n');

  // additionally respect the character limit
  if (result.length > props.charLimit) {
    result = result.slice(0, props.charLimit).trimEnd();
  }
  return result;
});

const toggle = () => {
  if (isDisabled.value) return;
  isMore.value = !isMore.value;
};
</script>

<style scoped>
.toggler{
  cursor: pointer;
  user-select: none;
  color: var(--un-text-color-gray-light);
}

.toggler.less{
  margin-left: 0.25rem;
}

.cont{
  white-space: pre-wrap;
  word-break: break-word;
}

.content{
  white-space: pre-wrap;
  word-break: break-word;
}

/* hide the toggler when not needed */
.show.disabled .toggler{
  display: none;
}
</style>
